var Backbone = require('backbone');
var Nunjucks = require('view');
var template = require('./tr-cardapio-atual.twig');

var View = Backbone.View.extend({
	tagName: 'tr',
	initialize: function(config) {
		var that = this;


		that.CardapioAtual = config.CardapioAtual;

		that.listenTo(that.model, 'remove', that.remove);
		that.listenTo(that.model, 'change', that.render);

		that.render();	
	},
	events: {
		'click .remove-product': 'removerProduto'
	},
	removerProduto: function() {
		var that = this;
		that.CardapioAtual.remove(that.model);
	},
	render: function() {
		var that = this;

		var data = that.model.toJSON();

		var html = Nunjucks.renderString(template, data);
		that.$el.html(html);		
	}
});

module.exports =  View;



//////////////////
// WEBPACK FOOTER
// ./views/kits/dialog-cardapio/tr-cardapio-atual.js
// module id = 42
// module chunks = 0